import React from 'react';
import { Link } from 'react-router-dom';
import { FOOTER_LINKS, NAV_ITEMS } from '../data/site';
import { AgreexaMark } from './AgreexaMark';
export function SiteFooter() {
  return <footer className="bg-ink text-paper mt-24" data-id="element-143">
      <div className="max-w-editorial mx-auto px-6 py-16" data-id="element-144">
        <div className="grid gap-12 md:grid-cols-12" data-id="element-145">
          <div className="md:col-span-5" data-id="element-146">
            <p className="font-serif text-2xl tracking-tightest" style={{
            fontWeight: 600
          }} data-id="element-147">
              Home Independence Hub
              <sup className="text-[0.5em] align-super ml-0.5" data-id="element-148">™</sup>
            </p>
            <p className="mt-3 text-stone-400 text-sm leading-relaxed max-w-sm" data-id="element-149">
              Independent research, transparent reviews and practical solutions
              for an energy-independent, prepared and self-sufficient home.
            </p>

            <div className="mt-8 flex items-center gap-3" data-id="element-150">
              <span className="eyebrow text-stone-500" style={{
              fontSize: '0.6rem'
            }} data-id="element-151">
                Powered by
              </span>
              <AgreexaMark tone="light" showTagline data-id="element-152" />
            </div>
          </div>

          <div className="md:col-span-3" data-id="element-153">
            <h2 className="eyebrow text-stone-500 mb-4" data-id="element-154">Explore</h2>
            <ul className="space-y-2.5" data-id="element-155">
              {NAV_ITEMS.slice(1, 8).map(item => <li key={item.to + item.label} data-id="element-156">
                  <Link to={item.to} className="text-sm text-stone-300 hover:text-paper transition-colors" data-id="element-157">
                    {item.label}
                  </Link>
                </li>)}
            </ul>
          </div>

          <div className="md:col-span-4" data-id="element-158">
            <h2 className="eyebrow text-stone-500 mb-4" data-id="element-159">
              Trust &amp; Transparency
            </h2>
            <ul className="space-y-2.5" data-id="element-160">
              {FOOTER_LINKS.map(item => <li key={item.label} data-id="element-161">
                  <Link to={item.to} className="text-sm text-stone-300 hover:text-paper transition-colors" data-id="element-162">
                    {item.label}
                  </Link>
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-stone-800 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4" data-id="element-163">
          <p className="text-xs text-stone-500" data-id="element-164">
            © {new Date().getFullYear()} Home Independence Hub. An Agreexa®
            publication.
          </p>
          <p className="text-xs text-stone-500 max-w-md" data-id="element-165">
            Every recommendation is independently evaluated under the Agreexa
            Trust Framework®.
          </p>
        </div>
      </div>
    </footer>;
}